"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var DataObjectListConverter_1 = require("../core/conversions/DataObjectListConverter");

var AppModule_1 = require("../core/modules/AppModule");

var DummyWindowAppendDTOConverter_1 = require("./conversions/DummyWindowAppendDTOConverter");

var DummyWindowAppendDTOConverterImpl_1 = require("./conversions/DummyWindowAppendDTOConverterImpl");

var ForecastSimulationConflictDTOConverter_1 = require("./conversions/ForecastSimulationConflictDTOConverter");

var ForecastSimulationConflictDTOConverterImpl_1 = require("./conversions/ForecastSimulationConflictDTOConverterImpl");

var ForecastSimulationConflictNodeDTOConverter_1 = require("./conversions/ForecastSimulationConflictNodeDTOConverter");

var ForecastSimulationConflictNodeDTOConverterImpl_1 = require("./conversions/ForecastSimulationConflictNodeDTOConverterImpl");

var ForecastSimulationLockDTOConverter_1 = require("./conversions/ForecastSimulationLockDTOConverter");

var ForecastSimulationLockDTOConverterImpl_1 = require("./conversions/ForecastSimulationLockDTOConverterImpl");

var ForecastSimulationSaveResultDTOConverter_1 = require("./conversions/ForecastSimulationSaveResultDTOConverter");

var ForecastSimulationSaveResultDTOConverterImpl_1 = require("./conversions/ForecastSimulationSaveResultDTOConverterImpl");

var ForecastSimulationTreeDataDTOConverterImpl_1 = require("./conversions/ForecastSimulationTreeDataDTOConverterImpl");

var ForecastSimulationUpdateDTOConverter_1 = require("./conversions/ForecastSimulationUpdateDTOConverter");

var ForecastSimulationUpdateDTOConverterImpl_1 = require("./conversions/ForecastSimulationUpdateDTOConverterImpl");

var ForecastSimulationUpdateResultDTOConverter_1 = require("./conversions/ForecastSimulationUpdateResultDTOConverter");

var ForecastSimulationUpdateResultDTOConverterImpl_1 = require("./conversions/ForecastSimulationUpdateResultDTOConverterImpl");

var SimulatedColumnConverter_1 = require("./conversions/SimulatedColumnConverter");

var SimulatedColumnConverterImpl_1 = require("./conversions/SimulatedColumnConverterImpl");

var SimulatedKpiValueDTOConverter_1 = require("./conversions/SimulatedKpiValueDTOConverter");

var SimulatedKpiValueDTOConverterImpl_1 = require("./conversions/SimulatedKpiValueDTOConverterImpl");

var SimulationFindCreateDTOConverter_1 = require("./conversions/SimulationFindCreateDTOConverter");

var SimulationFindCreateDTOConverterImpl_1 = require("./conversions/SimulationFindCreateDTOConverterImpl");

var TreeInfoDTOConverter_1 = require("./conversions/TreeInfoDTOConverter");

var TreeInfoDTOConverterImpl_1 = require("./conversions/TreeInfoDTOConverterImpl");

var ForecastSimulationTreeDataDTO_1 = require("./model/ForecastSimulationTreeDataDTO");

var ForecastSimulationAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(ForecastSimulationAppModule, _AppModule_1$AppModul);

  function ForecastSimulationAppModule() {
    var _this;

    _classCallCheck(this, ForecastSimulationAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'forecastSimulationAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ForecastSimulationAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(ForecastSimulationConflictDTOConverter_1.ForecastSimulationConflictDTOConverter).to(ForecastSimulationConflictDTOConverterImpl_1.ForecastSimulationConflictDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ForecastSimulationConflictNodeDTOConverter_1.ForecastSimulationConflictNodeDTOConverter).to(ForecastSimulationConflictNodeDTOConverterImpl_1.ForecastSimulationConflictNodeDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SimulationFindCreateDTOConverter_1.SimulationFindCreateDTOConverter).to(SimulationFindCreateDTOConverterImpl_1.SimulationFindCreateDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(TreeInfoDTOConverter_1.TreeInfoDTOConverter).to(TreeInfoDTOConverterImpl_1.TreeInfoDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ForecastSimulationUpdateDTOConverter_1.ForecastSimulationUpdateDTOConverter).to(ForecastSimulationUpdateDTOConverterImpl_1.ForecastSimulationUpdateDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ForecastSimulationUpdateResultDTOConverter_1.ForecastSimulationUpdateResultDTOConverter).to(ForecastSimulationUpdateResultDTOConverterImpl_1.ForecastSimulationUpdateResultDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ForecastSimulationSaveResultDTOConverter_1.ForecastSimulationSaveResultDTOConverter).to(ForecastSimulationSaveResultDTOConverterImpl_1.ForecastSimulationSaveResultDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ForecastSimulationLockDTOConverter_1.ForecastSimulationLockDTOConverter).to(ForecastSimulationLockDTOConverterImpl_1.ForecastSimulationLockDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(DummyWindowAppendDTOConverter_1.DummyWindowAppendDTOConverter).to(DummyWindowAppendDTOConverterImpl_1.DummyWindowAppendDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SimulatedColumnConverter_1.SimulatedColumnStringConverter).to(SimulatedColumnConverterImpl_1.SimulatedColumnStringConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SimulatedColumnConverter_1.SimulatedColumnBigNumConverter).to(SimulatedColumnConverterImpl_1.SimulatedColumnBigNumConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SimulatedKpiValueDTOConverter_1.SimulatedKpiValueDTOConverter).to(SimulatedKpiValueDTOConverterImpl_1.SimulatedKpiValueDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(DataObjectListConverter_1.DataObjectListConverter, {
        className: ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.name
      }).to(ForecastSimulationTreeDataDTOConverterImpl_1.ForecastSimulationTreeDataDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return ForecastSimulationAppModule;
}(AppModule_1.AppModule);

exports.ForecastSimulationAppModule = ForecastSimulationAppModule;